import { render, staticRenderFns } from "./PrestPopupVariantDefault.vue?vue&type=template&id=f5a904c8&scoped=true"
import script from "./PrestPopupVariantDefault.vue?vue&type=script&lang=ts&setup=true"
export * from "./PrestPopupVariantDefault.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./PrestPopupVariantDefault.vue?vue&type=style&index=0&id=f5a904c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5a904c8",
  null
  
)

export default component.exports